<template>
  <div class="card card-horizontal promo-card">
    <div
      class="card__thumbnail promo-card__thumbnail"
      :class="{ '__before-loaded': !isLoaded }"
    >
      <div class="card__discount" v-if="getDiscountPercentage(oferta) > 5">
        <span class="badge badge_discount">-{{ discount }}%</span>
      </div>
      <img
        @error="imgUrlAlt"
        @load="onImgLoad"
        :alt="oferta.ofr.obj.name"
        :src="getUrl(oferta)"
      />
    </div>
    <div class="card__content promo-card__content">
      <div class="mb-12">
        <h3 class="card__hotel-name promo-card__hotel-name mb-2">
          <a :href="getUrlOferta(oferta)" :title="oferta.ofr.obj.name">{{
            oferta.ofr.obj.name
          }}</a>
        </h3>
        <T1Stars class="card__category" :number="oferta.ofr.obj.category" />
      </div>

      <div class="card__details promo-card__details">
        <T1TripDetails
          :dateFrom="formatData(oferta.ofr.trp.startDate)"
          :dateTo="formatData(oferta.ofr.trp.rDesDate)"
          :depDesc="oferta.ofr.trp.depDesc"
          :duration="oferta.ofr.trp.duration"
          :service="getWyzywienie(oferta.ofr.obj.xServiceId)"
          :touropName="getTourop(oferta.ofr.tourOp)"
          :type="oferta.ofr.type"
          class="mb-12"
          iconSize="14"
        />

        <div class="promo-card__price">
          <div
            class="promo-card__old-price font-14 gray-30 text-crossed"
            v-if="getDiscountPercentage(oferta) > 5"
          >
            {{ getMaxPrice(oferta) }} zł/os.
          </div>
          <span>
            od:
            <span class="promo-card__price-value">{{ oferta.ofr.price }}</span>
            zł/os.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tourop } from "../tourops.js";
import { wyzywienie } from "../wyzywienie.js";
import T1Stars from "../T1Shared/T1Stars";
import T1TripDetails from "./T1TripDetails";

export default {
  name: "promo-offer-card",
  props: {
    oferta: [Array, Object],
  },
  data: () => ({
    tourop: tourop.tourops,
    wyzyw: wyzywienie.wyz,
    isLoaded: false,
  }),
  methods: {
    onImgLoad() {
      this.isLoaded = true;
    },
    formatData(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(6) +
          "." +
          data.substring(4, 6) +
          "." +
          data.substring(0, 4)
        );
      } else {
        return "";
      }
    },
    getUrl(oferta) {
      if (
        oferta.ofr &&
        oferta.ofr.datagourl !== undefined &&
        oferta.ofr.datagourl != ""
      ) {
        return "https://" + oferta.ofr.datagourl.replace(/T320/i, "T640");
      } else {
        let kontekst = "";
        let season = "";
        let tourOpfix = "";
        if (oferta.ofr.trp.season == 4) {
          season = "W";
        } else {
          season = "S";
        }
        if (
          (oferta.ofr.tourOp == "NPL" ||
            oferta.ofr.tourOp == "HIT" ||
            oferta.ofr.tourOp == "WYGO" ||
            oferta.ofr.tourOp == "TUIZ") &&
          season == "W"
        ) {
          kontekst = "winter/";
        }
        if (
          (oferta.ofr.tourOp == "NPL" ||
            oferta.ofr.tourOp == "HIT" ||
            oferta.ofr.tourOp == "WYGO" ||
            oferta.ofr.tourOp == "TUIZ") &&
          season == "S"
        ) {
          kontekst = "sommer/";
        }
        if (oferta.ofr.tourOp == "HIT") {
          tourOpfix = "NPL";
        } else if (
          oferta.ofr.tourOp == "ITAG" ||
          oferta.ofr.tourOp == "VITX" ||
          oferta.ofr.tourOp == "VITG"
        ) {
          tourOpfix = "ITAK";
        } else if (oferta.ofr.tourOp == "ECTR") {
          tourOpfix = "ECCO";
        } else {
          tourOpfix = oferta.ofr.tourOp;
        }
        return (
          "https://data2.merlinx.pl/" +
          tourOpfix +
          "/" +
          kontekst +
          tourOpfix +
          "-" +
          oferta.ofr.obj.code +
          "-0.jpg"
        );
      }
    },
    getFromDate(data) {
      if (data != null && data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    getHref(hurl) {
      if (hurl != null && hurl != "") {
        return hurl;
      } else {
        return "/hotele/hotel.xml";
      }
    },
    getUrlOferta(oferta) {
      let lparams = this.$route.query;
      let adt = 2;
      let chd = 0;
      let inf = 0;
      let chage = "";
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      if (lparams["chd"]) {
        chd = Number(lparams["chd"]);
      }
      if (lparams["inf"]) {
        inf = Number(lparams["inf"]);
      }
      if (lparams["chage"]) {
        chage = lparams["chage"];
      }
      //let link = 'https://www.wyspykanaryjskie.pl/merlinobiektmds-param.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      let link =
        this.getHref(oferta.ofr.hurl) +
        "?xCode=" +
        oferta.ofr.obj.xCode +
        "&tourOp=" +
        oferta.ofr.tourOp +
        "&htlCode=" +
        oferta.ofr.obj.code +
        "&kodId=" +
        oferta.ofr.id;
      link += "&adt=" + adt;
      if (chd > 0) {
        link += "&chd=" + chd;
      }
      if (chage != "") {
        link += "&chage=" + chage;
      }
      if (inf > 0) {
        link += "&inf=" + inf;
      }
      let fromDate = this.getFromDate(oferta.ofr.trp.startDate);
      if (fromDate != "") {
        link += "&fromDate=" + fromDate;
      }
      return link;
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer];
    },
    getTourop(tourop) {
      let tourOpName;
      if (tourop != null && tourop != "") {
        let items = this.tourop;
        items.forEach(function (obj) {
          if (obj.kod == tourop) {
            tourOpName = obj.nazwa;
          }
        });
        return tourOpName;
      } else {
        return "";
      }
    },
    getStars(oferta) {
      return "five-stars stars-" + oferta.ofr.obj.category;
    },
    imgUrlAlt(event) {
      //console.log(event);
      event.target.src =
        "https://www.travelone.pl/newimgs/zaslepka_lato_zest.jpg";
    },
    getDiscount(x, y) {
      return 100 - (x * 100) / y;
    },
    getMaxPrice(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        this.maxprice = oferta.ofr.extra.priceHistory.max;
      }
      return this.maxprice;
    },
    getDiscountPercentage(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        let price = oferta.ofr.price;
        let maxprice = oferta.ofr.extra.priceHistory.max;
        if (maxprice != price) {
          this.discount = Math.floor(
            this.getDiscount(Number(price), Number(maxprice))
          );
          return this.discount;
        }
      }
    },
  },
  components: {
    T1Stars,
    T1TripDetails,
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1OfferCards/T1CardCommonStyles";

.promo-card {
  &__hotel-name {
    @include text-truncate();
  }

  @media (max-width: $screen-sm-max) {
    flex-direction: column;

    &__thumbnail {
      height: 180px;
      width: 100%;
    }

    &__content {
      border-radius: 0 0 3px 3px;
      border-width: 0 1px 1px 1px;
      width: 100%;
    }

    &__price {
      flex-direction: column;
      text-align: right;
    }

    &__old-price {
      margin-bottom: 4px;
    }
  }

  @media (min-width: $screen-md) {
    height: 212px;

    &__thumbnail {
      height: 100%;
      max-width: 246px;
      width: 20vw;
    }

    &__content {
      border-radius: 0 3px 3px 0;
      border-width: 1px 1px 1px 0;
      overflow: hidden;
      width: 100%;
    }

    &__price {
      align-items: baseline;
      justify-content: flex-end;
    }

    &__old-price {
      margin-right: 8px;
    }
  }

  &__hotel-name {
    font-size: 19px;
  }

  &__price {
    display: flex;
    line-height: 1.1;
    margin-top: auto;
    white-space: nowrap;
  }

  &__price-value {
    font-size: 22px;
  }
}
</style>
